import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../components/Input';
import { withIntegerInLimits, withFloatInLimits } from './InputValidators';
import { InputCheckbox } from '../../components/InputsTable';
import { withErrorMessage, subscriptionAsText } from './renderers';
import styles from './styles.css';

const ThresholdsInput = (props) => <Input {...props} data-cy="threshold-input" styleName={props.empty ? 'empty' : 'disabled'} />;
ThresholdsInput.propTypes = {
  empty: PropTypes.bool,
};

export const academicThresholdColumns = [
  {
    name: 'enabled',
    header: 'Enabled',
    renderer: InputCheckbox,
  },
  {
    name: 'audience',
    header: 'Audience',
    renderer: subscriptionAsText,
  },
  {
    name: 'useDefault',
    header: 'Use Default Filter Values',
    renderer: withErrorMessage(InputCheckbox),
    disabledBy: '!enabled',
    style: styles.cell,
  },
  {
    name: 'gpa',
    header: 'Minimum GPA',
    renderer: withErrorMessage(withFloatInLimits(ThresholdsInput, 0.1, 4.0, 1)),
    disabledBy: '!enabled',
  },
  {
    name: 'sat',
    header: 'Minimum SAT Combined',
    renderer: withErrorMessage(withIntegerInLimits(ThresholdsInput, 400, 1600)),
    disabledBy: '!enabled',
  },
  {
    name: 'act',
    header: 'Minimum ACT Combined',
    renderer: withErrorMessage(withIntegerInLimits(ThresholdsInput, 1, 36)),
    disabledBy: '!enabled',
  },
];

export default academicThresholdColumns;
